
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../Static/PHPStatic/SubMenu.css'; // Import the CSS file

const SubMenu = ({ item }) => {
  const [subnav, setSubnav] = useState(false);

  const showSubnav = () => setSubnav(!subnav);

  return (
    <>
      <NavLink 
        className=' sidebar-link '
        to={item.path} 
        onClick={item.subNav && showSubnav}
      >
        <div>
          {item.icon}
          <span className="sidebar-label">{item.title}</span>
        </div>
        <div>
          {item.subNav && subnav
            ? item.iconOpened
            : item.subNav
            ? item.iconClosed
            : null}
        </div>
      </NavLink>
      {subnav &&
        item.subNav.map((subItem, index) => (
          <div key={index}>
            <NavLink 
              className={({ isActive }) => `dropdown-link ${isActive ? 'dropdown-link-active' : ''}`} 
              to={subItem.path}
            >
              <span className="sidebar-label">{subItem.title}</span>
            </NavLink>
            {subItem.subItem &&
              subItem.subItem.map((nestedItem, nestedIndex) => (
                <NavLink 
                  className={({ isActive }) => `dropdown-link ${isActive ? 'dropdown-link-active' : ''}`} 
                  to={nestedItem.path} 
                  key={nestedIndex}
                >
                  {nestedItem.icon}
                  <span className="sidebar-label">{nestedItem.title}</span>
                </NavLink>
              ))}
          </div>
        ))}
    </>
  );
};

export default React.memo(SubMenu);
